import { Switch } from "@shared/ui";
import { DisabledPopover } from "@shared/ui/DisabledPopover";
import { Collapse, CollapseProps, SwitchProps } from "antd";
import classNames from "classnames";
import { Sparkles } from "lucide-react";
import styles from "./styles.module.scss";

export default function CollapsibleCard({
  collapseProps,
  switchProps,
  isDisabled,
  reason,
}: {
  collapseProps: CollapseProps;
  switchProps: SwitchProps;
  isDisabled?: boolean;
  reason?: string;
}) {
  return (
    <Collapse
      className={styles.collapse}
      expandIconPosition="end"
      expandIcon={(panelProps) => (
        <DisabledPopover isDisabled={isDisabled || false} content={reason}>
          <Switch
            checked={panelProps.isActive}
            disabled={isDisabled || false}
            checkedChildren={
              <Sparkles fill="#635bff" color="#635bff" size={12} />
            }
            unCheckedChildren={
              <Sparkles fill="#a3acb9" color="#a3acb9" size={12} />
            }
            size="default"
            className={classNames(styles.switch, switchProps.className)}
            {...switchProps}
          />
        </DisabledPopover>
      )}
      {...collapseProps}
    />
  );
}
